import type { ReactNode } from "react";
import { useEffect } from "react";
import { LocalizationContext } from "../contexts/localizationContext";
import { useLocalizationState } from "./hooks";
import {
  registerTranslateFunction,
  unregisterTranslateFunction,
} from "../utils/showToast";

/**
 * Провайдер локализации приложения
 *
 * Отвечает за:
 * - Определение текущей локали (из профиля пользователя или браузера)
 * - Предоставление функции перевода t()
 * - Предоставление функции смены локали
 */
export const LocalizationProvider = ({ children }: { children: ReactNode }) => {
  const state = useLocalizationState();

  // Регистрируем функцию перевода для использования в showToast утилите
  useEffect(() => {
    registerTranslateFunction(state.t);
    return () => {
      unregisterTranslateFunction();
    };
  }, [state.t]);

  return (
    <LocalizationContext.Provider value={state}>
      {children}
    </LocalizationContext.Provider>
  );
};
